
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: '[fxV], cbre-fx-vertical',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FxVerticalLayoutComponent {
  @HostBinding('class') fxClass = 'fx--v';
}
